import React, { createContext, useEffect, useState } from "react";
import { AdminUser } from "../entry/server/user.ts";

type Message = {
    type: "success" | "error" | "info";
    message: string;
}

type AppContextType = {
    user: AdminUser | null;
    setUser: (user: AdminUser | null) => void;
    message: Message | null;
    setMessage: (message: Message | null) => void;
}

const initialState: AppContextType = {
    user: null,
    setUser: () => {},
    message: null,
    setMessage: () => {},
}

export const AppContext = createContext(initialState);

type AppProviderProps = {
    children?: any;
};

function readStoredUser(): AdminUser | null {
    const stored = sessionStorage.getItem("user");
    if (!stored) return null;
    try {
        return JSON.parse(stored) as AdminUser;
    } catch {
        return null;
    }
}

export const AppProvider = ({ children }: AppProviderProps) => {
    const [user, setUser] = useState(readStoredUser);
    const [message, setMessage] = useState(initialState.message as Message | null);

    useEffect(() => {
        if (message) {
            setTimeout(() => {
                setMessage(null);
            }, 5000);
        }
    }, [message]);
    return <AppContext.Provider value={{ user, setUser, message, setMessage }}>{children}</AppContext.Provider>;
};